// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.experiments.RentalManagerUserExperimentWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserExperimentWebApiHandler_getTreatment,
  RentalManagerUserExperimentWebApiHandler_getTreatment_Path,
  RentalManagerUserExperimentWebApiHandler_list,
  RentalManagerUserExperimentWebApiHandler_list_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ExperimentGetDto, ExperimentListDto, ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface GetTreatmentParams {
  featureName: string;
  listingAlias?: ListingAlias;
}

export type RentalManagerUserExperimentWebApiHandler_getTreatment_Options = UseQueryOptions<
  ExperimentGetDto,
  unknown,
  ExperimentGetDto,
  readonly [string, GetTreatmentParams]
>;

const RentalManagerUserExperimentWebApiHandler_getTreatment_GetKey = (getParams: GetTreatmentParams) =>
  [RentalManagerUserExperimentWebApiHandler_getTreatment_Path, getParams] as const;

export const RentalManagerUserExperimentWebApiHandler_getTreatment_queryOptions = (
  getParams: GetTreatmentParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserExperimentWebApiHandler_getTreatment_GetKey(getParams),
    queryFn: () => RentalManagerUserExperimentWebApiHandler_getTreatment(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get treatment for a given feature name
 */
export const useRentalManagerUserExperimentWebApiHandler_getTreatment = (
  getParams: GetTreatmentParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserExperimentWebApiHandler_getTreatment_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserExperimentWebApiHandler_getTreatment_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserExperimentWebApiHandler_getTreatment.getKey =
  RentalManagerUserExperimentWebApiHandler_getTreatment_GetKey;

export type RentalManagerUserExperimentWebApiHandler_list_Options = UseQueryOptions<
  ExperimentListDto,
  unknown,
  ExperimentListDto,
  readonly [string]
>;

const RentalManagerUserExperimentWebApiHandler_list_GetKey = () =>
  [RentalManagerUserExperimentWebApiHandler_list_Path] as const;

export const RentalManagerUserExperimentWebApiHandler_list_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserExperimentWebApiHandler_list_GetKey(),
    queryFn: () => RentalManagerUserExperimentWebApiHandler_list(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get list of experiments
 */
export const useRentalManagerUserExperimentWebApiHandler_list = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserExperimentWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserExperimentWebApiHandler_list_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserExperimentWebApiHandler_list.getKey = RentalManagerUserExperimentWebApiHandler_list_GetKey;
